/** =========================================================
 * Module: browser.js
 * Browser detection
 =========================================================*/

(function () {
  'use strict';

  angular
    .module('app.utils')
    .service('Browser', Browser);

  Browser.$inject = ['$window'];

  function Browser($window) {
    return $window.jQBrowser;
  }
})();
